module.exports = __webpack_public_path__ + "media/images/metronic/portlet-expand-icon-white-f3d3f09ec5b7a52232a8d20bd4c49d3c.png";